import FadeIn from 'legacy/common/components/transition/FadeIn';
import React from 'react';
import { useTranslation } from 'react-i18next';
import PromoterDiscount from '../PromoterDiscount';
import InfoTooltip from 'legacy/common/components/wysiwyg-form/InfoTooltip';

interface AdvanceOptionsProps {
  setShowAdvanceOptions: (show: boolean) => void;
  eventId: string;
}

const AdvanceOptions = ({
  setShowAdvanceOptions,
  eventId
}: AdvanceOptionsProps) => {
  const { t } = useTranslation('events');
  
  const rule1 = t('settings.promoterOffers.advanceOptions.tooltipRules.rule1');
  const rule2 = t('settings.promoterOffers.advanceOptions.tooltipRules.rule2');
  const tooltipMessage = `1. ${rule1} 2. ${rule2}`;

  return (
    <FadeIn>
      <div>
        <div
          onClick={() => setShowAdvanceOptions(false)}
          className="text-sm font-bold text-[#3853C4] cursor-pointer"
        >
          {t('settings.promoterOffers.advanceOptions.hideAdvanceOptions')}
        </div>
        <div className="mt-10">
          <div className="items-center justify-start flex">
            <div className="text-base font-bold text-[#202020]">
              {t('settings.promoterOffers.advanceOptions.includeDiscount')}
            </div>
            <InfoTooltip id="tooltip" message={tooltipMessage} position="top" />
          </div>
          <div className="mt-2 text-[#575757] text-sm font-normal">
            {t('settings.promoterOffers.advanceOptions.discountDescription')}
          </div>
        </div>
        <PromoterDiscount eventId={eventId} />
      </div>
    </FadeIn>
  );
};

export default AdvanceOptions;
